/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, ContentChild, ElementRef, HostBinding, TemplateRef } from '@angular/core';
import { LiftContainer } from './lift-container.service';

@Component({
  standalone: false,
  selector: 'gh-lift',
  template: `
    <ng-content></ng-content>`,
  styleUrls: ['lift.component.scss'],
  exportAs: 'ghLift',
})
export class LiftComponent {
  @HostBinding('class.raised')
  raised: boolean = false;

  @ContentChild(TemplateRef, { static: false }) template: TemplateRef<any>;

  constructor(
    private container: LiftContainer,
    private elementRef: ElementRef<HTMLElement>,
  ) {}

  up(): void {
    this.raised = true;
    const parent = this.elementRef.nativeElement.parentElement ?? undefined;
    this.container.showOverlay(parent);
  }

  down(): void {
    this.container.hideOverlay();
    this.raised = false;
  }
}
